module.exports = __webpack_public_path__ + "img/health.83ef9c72.png";